import { useEffect, useState } from "react";
import withLoader from "../../components/layouts/WithLoader";
import BanqueService from "../../services/Banque";

import makeAnimated from "react-select/animated";
import Select from "react-select";
import TransfertAccountsCheque from "./PayementTransfertComptes/TransfertAccountsCheque";
import TransfertAccountsEspece from "./PayementTransfertComptes/TransfertAccountsEspece";
import TransfertAccountsVirement from "./PayementTransfertComptes/TransfertAccountsVirement";
import TransfertAccountsEnLigne from "./PayementTransfertComptes/TransfertAccountsEnLigne";
const AddTransfertBanqueAccounts = ({ startLoading, stopLoading }) => {
  const [options, setOptions] = useState([]);
  const [optionsDestination, setOptionsDestination] = useState([]);
  const [methodePayement, setMethodePayement] = useState();

  const [banquesAccount, setBanquesAccount] = useState([]);
  const [alert_message, setAlert_message] = useState("");
  const [selectedOptionSource, setSelectedOptionSource] = useState(null);
  const animatedComponents = makeAnimated();
  const [idAccountSource, setIdAccountSource] = useState(null);
  const [idAccountDestination, setIdAccountDestination] = useState(null);
  const [selectedOptionDestination, setSelectedOptionDestination] =
    useState(null);

  useEffect(() => {
    setOptions([]);
    BanqueService.getAllAccounts()
      .then((response) => {
        if (response.data["success"]) {
          // setBanquesAccount(response.data["success"]);
          // setAlert_message("success");
          const newOptions = response.data["success"].map((BA) => ({
            value: BA.idBankAccount,
            label: BA.rib + "-" + BA.name + "-" + BA.agenceLocalisation,
          }));
          // console.log("newOptions", newOptions);
          setOptions((prevOptions) => [...prevOptions, ...newOptions]);
          setOptionsDestination((prevOptions) => [
            ...prevOptions,
            ...newOptions,
          ]);
        }
      })
      .catch((error) => {
        setAlert_message("error " + error);
      });
  }, []);
  const handleChangeAccountSource = (selectedOption) => {
    setSelectedOptionSource(selectedOption);
    setIdAccountSource(selectedOption.value);
    localStorage.setItem("idBaSource", selectedOption.value);
    setOptionsDestination(
      optionsDestination.filter((x) => x.value !== selectedOption.value)
    );
  };

  const handleChangeAccountDestination = (selectedOption) => {
    setSelectedOptionDestination(selectedOption);

    setIdAccountDestination(selectedOption.value);
    localStorage.setItem("idBaDestination", selectedOption.value);
  };
  const handleChangePayement = (e) => {
    let payement = e.target.value;
    setMethodePayement(payement);
  };
  const createUIPayement = () => {
    if (methodePayement === "CHEQUE") {
      return <TransfertAccountsCheque />;
    } else if (methodePayement === "ESPECE") {
      return <TransfertAccountsEspece />;
    } else if (methodePayement === "VIREMENT") {
      return <TransfertAccountsVirement />;
    } else if (methodePayement === "ENLIGNE") {
      return <TransfertAccountsEnLigne />;
    }
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <br />
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div className="card card-dark">
              <div className="card-header">
                <h3 className="card-title">Transfert entre les comptes</h3>
              </div>

              <div className="card-body">
                <div class="row">
                  <div class="form-group  col-sm-4">
                    <div>
                      <label>Choisir les compte source</label>
                      <Select
                        value={selectedOptionSource}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={options}
                        onChange={handleChangeAccountSource}
                        placeholder={"Tous"}
                      />
                    </div>
                  </div>
                  <div class="form-group col-sm-4">
                    <div>
                      <label>Choisir les compte Destination</label>
                      <Select
                        value={selectedOptionDestination}
                        closeMenuOnSelect={true}
                        components={animatedComponents}
                        options={optionsDestination}
                        onChange={handleChangeAccountDestination}
                        placeholder={"Tous"}
                      />
                    </div>
                  </div>

                  <div class="col-sm-4">
                    <label>Choisir les compte source</label>

                    <select
                      class="form-control"
                      onChange={handleChangePayement}
                    >
                      <option key={0} value={0}>
                        Sélectionner un mode de payement
                      </option>
                      <option key={1} value={"ESPECE"}>
                        Espèce
                      </option>
                      <option key={2} value={"ENLIGNE"}>
                        En ligne
                      </option>
                      <option key={3} value={"CHEQUE"}>
                        Chèques / Traites
                      </option>
                      <option key={4} value={"VIREMENT"}>
                        Virement
                      </option>
                    </select>
                  </div>
                </div>
                {createUIPayement()}
              </div>
            </div>
          </div>{" "}
        </div>
      </section>
    </div>
  );
};
export default withLoader(AddTransfertBanqueAccounts);
